import { gql } from "@apollo/client";

export const GET_MASTER_LOOKUP_BY_TYPE = gql`
  query GetMasterLookupByType($type: String!) {
    getMasterLookupByType(type: $type) {
      success
      message
      data {
        id
        type
        key
        title
        min_value
        max_value
        is_active
        created_at
        updated_at
      }
    }
  }
`;

export const GET_MASTER_LOOKUP_ID_BY_KEY = gql`
  query GetMasterLookupIdByKey($type: String!, $key: String!) {
    getMasterLookupIdByKey(type: $type, key: $key) {
      success
      message
      id
    }
  }
`;

export const GET_LATEST_CHECK_RESULTS = gql`
  query getLatestCheckResults($check_id: Int!) {
    getLatestCheckResults(check_id: $check_id) {
      resource_id
      resource_name
    }
  }
`;

export const GET_LATEST_CHECK_RUN_STATUS = gql`
  query getLatestCheckRunStatus($check_id: Int!) {
    getLatestCheckRunStatus(check_id: $check_id) {
      run_status
      id
      updated_at
    }
  }
`;
